import { WidgetRegistry } from './widget-registry.token';
import { TextWidgetComponent } from '../widgets/text/text.component';
import { SpacerWidgetComponent } from '../widgets/spacer/spacer.component';
import { ImageWidgetComponent } from '../widgets/image/image.component';
import { ButtonsWidgetComponent } from '../widgets/buttons/buttons.component';
import { VideoWidgetComponent } from '../widgets/video/video.component';
import { CallToActionWidgetComponent } from '../widgets/cta/cta.component';
import { BillboardImageWidgetComponent } from '../widgets/billboard-image/billboard-image.component';
import { CountdownWidgetComponent } from '../widgets/countdown/countdown.component';
import { AnnotatedMapWidgetComponent } from '../widgets/annotated-map/annotated-map.component';
import { ImagesWidgetComponent } from '../widgets/images/images.component';
import { FormWidgetComponent } from '../widgets/form/form.component';

export const DEFAULT_WIDGET_REGISTRY: WidgetRegistry = {
  text: TextWidgetComponent,
  spacer: SpacerWidgetComponent,
  image: ImageWidgetComponent,
  images: ImagesWidgetComponent,
  billboardImage: BillboardImageWidgetComponent,
  buttons: ButtonsWidgetComponent,
  video: VideoWidgetComponent,
  billboardVideo: VideoWidgetComponent,
  splashVideo: VideoWidgetComponent,
  callToAction: CallToActionWidgetComponent,
  countdown: CountdownWidgetComponent,
  annotatedMap: AnnotatedMapWidgetComponent,
  form: FormWidgetComponent
};